import {Business} from '../Business';
import axios from 'axios';
import {get} from "lodash";

const baseUrl = 'https://b5cat8uo15.execute-api.ap-south-1.amazonaws.com/dev/v1';
const url = `${baseUrl}/business`;

function translateStatusToErrorMessage(status: number) {
  switch (status) {
    case 401:
      return 'Please login again.';
    case 403:
      return 'You do not have permission to view the business(es).';
    default:
      return 'There was an error retrieving the Business(es). Please try again.';
  }
}

function checkStatus(response: any) {
  if (response.ok) {
    return response;
  } else {
    const httpErrorInfo = {
      status: response.status,
      statusText: response.statusText,
      url: response.url,
    };
    console.log(`log server http error: ${JSON.stringify(httpErrorInfo)}`);

    let errorMessage = translateStatusToErrorMessage(httpErrorInfo.status);
    throw new Error(errorMessage);
  }
}


function convertToBusinessModels(data: any[]): Business[] {
  let projects: Business[] = data.map(convertToBusinessModel);
  return projects;
}

function convertToBusinessModel(item: any): Business {
  return new Business(item);
}

const businessAPI = {
  async get(page = 1, limit = 20) {
    const axiosInstance = axios.create();
    try {
      const response = await axiosInstance.get(`${url}`, {
        headers: {
          'x-api-key': '8uSkKD665MaTLtEqezJtq41QQTwLc85I7uIXvTyQ'
        }
      });
        return convertToBusinessModels(response.data);

    }catch(error: any) {
      console.log('log client error ' + get(error, "response.data"));
      throw new Error(get(error, "response.data.message", 'There was an error while getting the businesses. Please try again.'));
    }
  },
  async create(business: Business) {
    const axiosInstance = axios.create();
    try {
      const response = await axiosInstance.post(`${url}`, business, {
        headers: {
          'x-api-key': '8uSkKD665MaTLtEqezJtq41QQTwLc85I7uIXvTyQ'
        }
      });
      return convertToBusinessModel(response.data);
    } catch (error: any) {
      console.log('log client error ' + get(error, "response.data"));
      throw new Error(get(error, "response.data.message", 'There was an error saving the new business. Please try again.'));
    }
  },
  async put(business: Business) {
    const axiosInstance = axios.create();
    try {
      const response = await axiosInstance.put(`${url}/${business.id}`, business, {
        headers: {
          'x-api-key': '8uSkKD665MaTLtEqezJtq41QQTwLc85I7uIXvTyQ'
        }
      });
        return convertToBusinessModel(response.data);

    }catch(error: any) {
      console.log('log client error ' + get(error, "response.data"));
      throw new Error(get(error, "response.data.message", 'There was an error updating the new business. Please try again.'));
    }
  }
};

export { businessAPI };